import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";

function ModalConfirm({toggle, close, isOpen,onClick, args, text, title}) {
  return (
      <Modal isOpen={isOpen} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle} close={close}>
          <span className="t-primary fs-4 fw-bold">{title}</span>
        </ModalHeader>
        <ModalBody className="px-4">
          <form>
            <div>{text}</div>

            <div className="d-flex justify-content-between mt-4">
              <Button
                className="btn_no w-50 me-2"
                onClick={toggle}
              >
                No
              </Button>
              <Button
                className="btn_add w-50 ms-2"
                onClick={onClick}
              >
                Yes
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
  );
}

export default ModalConfirm;
